
import {
  computed,
  defineComponent, onMounted, onUnmounted, PropType, ref, Ref,
} from 'vue';
import { useRoute } from 'vue-router';
import { ICaseFilesManage, IMedia } from '@/types/interfaces';
import { useDriveStore } from '../../store/driveStore';
import DriveUiWrapper from './DriveUIWrapper.vue';
import {
  ACCOUNT_STATUS,
  BOTTOM_POPUP_TYPES, HIDE_BORDER, MEDIA_TYPES, PHOTO_VIEW_TYPE,
} from '@/types/enums';
import { useMainStore } from '@/store/mainStore';
import { lowResUrlByViewType } from '@/helpers/lowResPhotoUrl';
import AppSkeletonRect from '@/components/skeletons/AppSkeletonRect.vue';
import UploadFilesPopUp from '@/components/BottomPopUp/PopUpTypes/Upload/UploadFilesPopUp.vue';
import UploadPhotosPopUp from '@/components/BottomPopUp/PopUpTypes/Upload/UploadPhotosPopUp.vue';

export default defineComponent({
  props: {
    files: { type: Array as PropType<IMedia[]>, required: true },
    title: { type: String, required: true },
    isPhoto: { type: Boolean, default: false },
    hideBorder: { type: Number as () => HIDE_BORDER, default: HIDE_BORDER.NONE },
    isPreviewCase: { type: Boolean, default: false },
    skeletonAmount: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },

  },
  components: {
    DriveUiWrapper,
    AppSkeletonRect,
    UploadFilesPopUp,
    UploadPhotosPopUp,
  },
  emits: ['showPopUp'],
  setup(props) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();

    const fileInputButton: Ref<HTMLElement | null> = ref(null);
    const isUserPublicCase = computed(() => route.meta?.isUserPublicCase);

    const itemHeight: Ref<string> = ref('');
    const itemMargin: Ref<string> = ref('');
    const showPopUp = ref(false);
    const filesPopUpPos = ref({});

    function onResize() {
      if (props.isPhoto && fileInputButton.value) {
        itemHeight.value = `${fileInputButton.value!.offsetWidth}px`;
        itemMargin.value = `${(fileInputButton.value!.offsetWidth * 5) / 21.25}px`;
      } else if (!props.isPreviewCase && !isUserPublicCase.value) {
        itemHeight.value = `${fileInputButton.value!.offsetWidth}px`;
        itemMargin.value = `${(fileInputButton.value!.offsetWidth * 5) / 21.25}px`;
      }
    }

    function openPopUp() {
      if (props.disabled) {
        return;
      }
      if (props.isPhoto) {
        mainStore.BottomPopUpType = BOTTOM_POPUP_TYPES.UPLOAD_PHOTOS;
      } else {
        mainStore.BottomPopUpType = BOTTOM_POPUP_TYPES.UPLOAD_FILES;
      }
    }

    function openDesktopPopUp(event) {
      showPopUp.value = true;
      filesPopUpPos.value = { x: event.clientX - 370, y: event.clientY - 58 };
    }

    function hidePopUp() {
      showPopUp.value = false;
    }
    function removeItem(item: IMedia) {
      const payload = {
        id: driveStore.currentCase.id,
        fileIds: [item.id],
      } as ICaseFilesManage;

      const globalCase = driveStore.cases.data.find((cas) => cas.id === driveStore.currentCase.id);

      const updateTime = () => {
        driveStore.currentCase.updated = Date.now();
        if (globalCase) {
          globalCase.updated = Date.now();
        }
      };

      driveStore.removeFilesFromCase(payload).then(() => {
        updateTime();
        // NotificationService.notifySuccess();
      });
    }

    function resolvePhoto(photo: IMedia) {
      if (photo.type === MEDIA_TYPES.PHOTO) {
        return lowResUrlByViewType(photo, PHOTO_VIEW_TYPE.WHSML);
      }
      return process.env.VUE_APP_MEDIA_URL + photo.previewUrl;
    }

    onMounted(() => {
      window.addEventListener('resize', onResize);
      onResize();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', onResize);
    });

    return {
      fileInputButton,
      itemHeight,
      itemMargin,
      driveStore,
      resolvePhoto,
      openPopUp,
      removeItem,
      MEDIA_TYPES,
      mainStore,
      showPopUp,
      openDesktopPopUp,
      hidePopUp,
      filesPopUpPos,
      isUserPublicCase,
    };
  },
});
